




















import { computed, defineComponent, ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { useBecomeCreatorState } from "@/hooks/useBecomeCreatorState";
import useFullCreatorApplicationUpload from "@/hooks/useFullCreatorApplicationUpload";
import useUserVerification from "@/hooks/useUserVerification";
import providers from "@/lib/api";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import FullCreatorForm from "./components/FullCreatorForm";
import LimitedCreatorForm from "./components/LimitedCreatorForm";
import PromoteView from "./components/PromoteView.vue";

export default defineComponent({
  name: "PageBecomeCreator",
  components: {
    FullCreatorForm,
    LimitedCreatorForm,
    PromoteView,
    PageTitle,
    BasePage,
  },
  setup(_, { root }) {
    const { authUserStrict, userVerificationStatus, isCreator, updateUser } = useAuthUser();
    const { start, startUpgradeStatus, findMyStatus } = useUserVerification();
    const { submitApplicationAfterPublishing } = useFullCreatorApplicationUpload();
    const { update: updateBecomeCreatorState } = useBecomeCreatorState();

    const showPromote = ref(true);
    const valid = ref(false);
    const loading = ref(false);
    const sendingData = ref(false);
    const showLimitedCreatorForm = computed(() => userVerificationStatus.value === "UNVERIFIED" && !showPromote.value);

    const startUserVerification = async () => {
      try {
        sendingData.value = true;
        await start(authUserStrict.value.id);
        // emit("form:finishStep");
        await findMyStatus();
        const { role, authorities } = await providers.UserProvider.getMyAuthorities();
        updateUser({ ...authUserStrict.value, role }, authorities);
        showPromote.value = true;
      } finally {
        sendingData.value = false;
      }
    };

    const startUserVerificationUpgradeStatus = async () => {
      try {
        sendingData.value = true;
        void submitApplicationAfterPublishing(
          async () => {
            await startUpgradeStatus(authUserStrict.value.id);
          },
          async () => {
            await updateBecomeCreatorState(0, null);
            // emit("form:finishStep");
            await findMyStatus();
            const { role, authorities } = await providers.UserProvider.getMyAuthorities();
            updateUser({ ...authUserStrict.value, role }, authorities);
          }
        );
        root.$router?.push({ name: "profilePayeeInfo" });
      } finally {
        sendingData.value = false;
      }
    };

    const getData = async () => {
      try {
        loading.value = true;
        await findMyStatus();
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      isCreator,
      showLimitedCreatorForm,
      showPromote,
      loading,
      valid,
      startUserVerification,
      startUserVerificationUpgradeStatus,
    };
  },
});
